import { usePermissions } from "@/rbac";
import { permissions } from "@/rbac/permissions";
import { TransactionResp } from "@/types/transaction.type";
import { ColumnDef } from "@tanstack/react-table";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import PreviewImage from "./_reviewImage";
import Tooltip from "@/components/Tooltip";
import { TypeTransaction } from "@/constants/enum";

export default function TableHeader(): ColumnDef<TransactionResp>[] {
    const {t} = useTranslation();
    const { hasPermission } = usePermissions();
    const navigate = useNavigate()
    const location = useLocation()

    const handleViewImage = (row: TransactionResp) => {
        row.images.forEach((item) => {
            window.open(item.image_url, '_blank');
        })
    }

    return [
        {
            id: 'business_unit_name',
            header: t("transaction.business_unit"),
            accessorKey: "business_unit_name",
        },
        {
            id: 'transaction_type_name',
            header: t("transaction.category"),
            accessorKey: "transaction_type_name",
        },
        {
            header: t("transaction.date"),
            accessorKey: "date",
            cell: ({row}) => moment(row.original.date).format("MMM DD YYYY")
        },
        {
            header: t("form.description"),
            accessorKey: "description",
            enableSorting: false
        },
        {
            id: 'unit_code_code',
            header: t("transaction.transaction_code"),
            accessorKey: "unit_code_code",
            cell: ({row}) =>  <>
                <p>
                    {row.original.unit_code_code}
                </p>
                <small>{row.original.unit_code_name}</small>
            </>
        },
        {
            header: t("transaction.deposit"),
            accessorKey: "amount_deposit",
            cell: ({row}) => {
                return row.original.amount_deposit > 0 && <span className="text-meta-3">{row.original.amount_deposit.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})}</span>
            }
        },
        {
            header: t("transaction.withdraw"),
            accessorKey: "amount_withdraw",
            cell: ({row}) => {
                return row.original.amount_withdraw > 0 && <span className="text-red">{row.original.amount_withdraw.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})}</span>
            }
        },
        {
            header: t("transaction.balance"),
            accessorKey: "balance",
            enableSorting: false,
            cell: ({row}) => {
                return <span className="text-meta-5">{row.original.balance < 0 ? "- " : ""}{Math.abs(row.original.balance).toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})}</span>
            }
        },
        {
            header: t("table.action"),
            accessorKey: "action",
            enableSorting: false,
            cell: ({ row }) => (
                <div className="flex items-center justify-end gap-3">
                    {
                        row.original.images ?
                            // <PreviewImage images={row.original.images}>
                            //     <button className="hover:text-warning" type="button">
                            //         <i className="fa-sharp fa-light fa-eye" />
                            //     </button>
                            // </PreviewImage>
                            <button className="hover:text-warning" type="button" onClick={() => navigate(location , {state: {modal: "/transactions/image", images: row.original.images.map((item) => item.image_url)}})}>
                                <i className="fa-sharp fa-light fa-eye" />
                            </button>
                            :
                            (
                                row.original.type === TypeTransaction.WITHDRAW &&  <Tooltip text={t("transaction.missing_document")}>
                                    <i className="fa-solid fa-circle-exclamation text-red-700"></i>
                                </Tooltip>
                            )
                    }
                    {
                        hasPermission(permissions.TRANSACTION.EDIT) && <Tooltip text={t("form.edit")}>
                            <button className="group flex relative hover:text-primary" onClick={() => navigate(location , {state: {modal: "/transactions/edit", id: row.original.id}})}>
                                <i className="fa-sharp fa-light fa-pencil" />
                            </button>
                      </Tooltip>
                    }
                    {
                        hasPermission(permissions.TRANSACTION.DELETE) && <Tooltip text={t("form.delete")}>
                            <button className="group flex relative hover:text-danger" onClick={() => navigate(location , {state: {modal: "/transactions/delete", id: row.original.id}})}>
                                <i className="fa-sharp fa-light fa-trash-can" />
                            </button>
                        </Tooltip>
                    }
                </div>
            )
        }
    ]
}
